import React, { useEffect } from 'react';
import Spinner from '../../globalComponents/spinner';
import SpinnerSize from '../../enums/spinnerSize';
import { useApi } from '../../hooks/useApi';
import { useNavigate } from 'react-router-dom';
import auth from '../utils/auth';

const CognitoLogin: React.FC = () => {
	const api = useApi();
	const navigate = useNavigate();
	const queryParams = new URLSearchParams(window.location.search);
	const code = queryParams.get('code');

	useEffect(() => {
		if (auth) {
			if (code) {
				(async () => {
					await api.cognito.loginWithCode(code, auth);
					navigate('/');
				})();
			} else {
				navigate('/login');
			}
		}
	}, [auth]);

	return (
		<div className="w-[100vw] h-[100vh] flex justify-center items-center">
			<Spinner size={SpinnerSize.LARGE} />
		</div>
	);
};

export default CognitoLogin;
